import React, { FC } from 'react';
import { Error } from '@mui/icons-material';
import Box from '@mui/material/Box';
import DropZone from './DropZone';
import FileRow from './FileRow';
import { FileManaged } from '../../../structures/response/FileManaged';
import styles from './DropZoneUploader.module.scss';

interface Props {
  onDrop: (acceptedFiles: File[]) => Promise<void>;
  onDelete: (v: FileManaged | File) => Promise<void>;
  uploaded?: FileManaged[];
  selected?: File[];
  accept?: string;
  acceptLabel?: string;
  errorText?: string;
  hasError?: boolean;
}

const DropZoneUploader: FC<Props> = ({
  uploaded = [],
  selected = [],
  onDrop,
  onDelete,
  acceptLabel,
  accept,
  errorText,
  hasError,
}: Props) => {
  const hasUploaded = Array.isArray(uploaded) && uploaded.length > 0;
  const hasSelected = Array.isArray(selected) && selected.length > 0;
  return (
    <div>
      {(hasUploaded || hasSelected) && (
        <Box sx={{ mb: 3 }}>
          {hasUploaded &&
            uploaded.map((v) => (
              <FileRow key={v.id} file={v} onDelete={onDelete} />
            ))}
          {hasSelected &&
            selected.map((v) => (
              <FileRow key={v.name + v.size} file={v} onDelete={onDelete} />
            ))}
        </Box>
      )}
      <DropZone accept={accept} acceptLabel={acceptLabel} handleDrop={onDrop} />
      {Boolean(hasError) && (
        <div className={`error-text text-center Mui-error ${styles.errorText}`}>
          {hasError && <Error className={styles.errorIcon} />} {errorText}
        </div>
      )}
    </div>
  );
};

DropZoneUploader.defaultProps = {
  accept: '.jpg,.png,.gif,.odt,.doc,.txt,.pdf',
  acceptLabel: 'jpg, png, gif, odt, doc, txt, pdf',
  errorText: '',
  hasError: false,
};

export default DropZoneUploader;
